module.exports = "/_next/static/images/69ea65738c03c19f52dbd47f14b8d140-nubanker-eng@3x.jpg.webp";